import "./App.css";
import "./styles.css";
import { trackPageView, trackPerformanceMetric } from "./utils/analytics";

import React, { useEffect } from "react";

import { Elements } from "@stripe/react-stripe-js";
import { CheckoutForm } from "./CheckoutForm";
import { MultiPaymentForm } from "./MultiPaymentForm";
import PaymentPreviewPage from "./PaymentPreviewPage";
import PaymentResultPage from "./PaymentResultPage";
import { getStripePromise } from "./stripePromiseTest";
import Footer from "./Footer";

const App = () => {
  const pathname = window.location.pathname.replace(/\/+$/, "") || "/";
  const isPaymentResultRoute = pathname === "/result";
  const isPreviewMode = getPreviewMode();

  useEffect(() => {
    trackPageView(
      isPreviewMode
        ? isPaymentResultRoute
          ? "payment_result_preview"
          : "checkout_preview"
        : isPaymentResultRoute
          ? "payment_result"
          : "checkout",
    );

    const pageLoadTime =
      window.performance.timing.loadEventEnd -
      window.performance.timing.navigationStart;
    trackPerformanceMetric("page_load_time", pageLoadTime, {
      isLive: getLiveMode(),
    });
  }, [isPaymentResultRoute, isPreviewMode]);

  const useMulti = getQueryVariable("UseMulti");
  const FormComponent = useMulti === "1" ? MultiPaymentForm : CheckoutForm;
  const stripe = getStripePromise(getLiveMode());

  return (
    <div className="fullWindow">
      <div className="PaymentPageShell">
        <div className="AppWrapper">
          {isPaymentResultRoute ? (
            <PaymentResultPage />
          ) : isPreviewMode ? (
            <PaymentPreviewPage />
          ) : useMulti === "1" ? (
            <FormComponent />
          ) : (
            <Elements stripe={stripe}>
              <FormComponent />
            </Elements>
          )}
          <div className="powered-by-stripe">Secure payment powered by Stripe</div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;

const getQueryVariable = (key) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

const getLiveMode = () => getQueryVariable("IsLive") !== "TEST";
const getPreviewMode = () => getQueryVariable("preview") === "1";

const getPaymentReturnUrl = (tourId) => {
  const url = new URL(`${window.location.origin}/result`);
  if (tourId) {
    url.searchParams.set("tourId", tourId);
  }
  const isLive = getQueryVariable("IsLive");
  if (isLive) {
    url.searchParams.set("IsLive", isLive);
  }
  const useMulti = getQueryVariable("UseMulti");
  if (useMulti) {
    url.searchParams.set("UseMulti", useMulti);
  }
  return url.toString();
};

const getCheckoutUrl = (tourId) => {
  const url = new URL(window.location.origin);
  if (tourId) {
    url.searchParams.set("TourId", tourId);
  }
  const isLive = getQueryVariable("IsLive");
  if (isLive) {
    url.searchParams.set("IsLive", isLive);
  }
  const useMulti = getQueryVariable("UseMulti");
  if (useMulti) {
    url.searchParams.set("UseMulti", useMulti);
  }
  return url.toString();
};

export {
  getLiveMode,
  getQueryVariable,
  getPaymentReturnUrl,
  getPreviewMode,
  getCheckoutUrl,
};
